import React from 'react'
import { Flex } from '@chakra-ui/react'

import {
    PatientFieldsFragment,
    PatientVaccinationRecordFieldsFragment,
} from '~graphql/generated/graphql'
import ExportVaccinationRecordsButton from './export-button'
import ShareVaccinationRecordsButton from './share-button'

interface Props {
    patient: PatientFieldsFragment
    vaccines: PatientVaccinationRecordFieldsFragment[]
    /** Patient page always shows Export; drawer only when records exist. */
    alwaysShowExport?: boolean
}

/**
 * Shared Share + PDF export actions for patient vaccine records.
 * Used on the full patient Vaccines tab and the Inbox patient drawer.
 */
export default function VaccinationRecordsActions({
    patient,
    vaccines,
    alwaysShowExport = false,
}: Props) {
    const hasVaccines = vaccines.length > 0
    const showExport = alwaysShowExport || hasVaccines

    if (!hasVaccines && !showExport) return null

    return (
        <Flex gap={2}>
            {hasVaccines && <ShareVaccinationRecordsButton patient={patient} />}
            {showExport && (
                <ExportVaccinationRecordsButton
                    patient={patient}
                    vaccines={vaccines}
                />
            )}
        </Flex>
    )
}
